import GeneralSchema from "@/Config/ImportJob/CreateNewJob/General/GeneralDetailsSchema";
import { mapExporterRequest } from "@/redux/mappers/Export/CreateNewJob/generalMapper";
import EntitySchema from "@/Config/ImportJob/CreateNewJob/Entity/EntityCustomizedList";
// import ContainerSchema from "@/Config/ImportJob/CreateNewJob/";
import ShipmentMainJson from "@/Config/ImportJob/CreateNewJob/Shipment/Shipment";
// import InvoiceSummaryCard from "@/Views/ExportJob/CreateNewJob/InvoiceTab/InvoiceSummaryCard";
// import ProductMain from "@/Config/Export/CreateNewJob/ProductJsons/ProductMain";
import ProductOther from "@/Config/ImportJob/CreateNewJob/Product/OtherDts";
// import ProductGeneral from "./ProductJsons/ProductGeneral";
// import ProductDrawTop from "./ProductJsons/ProductDrawTop";
// import InvoiceDialog from "@/Config/Export/CreateNewJob/Invoice/InvoiceTable";
// import InvoiceBuyer from "@/Config/Export/CreateNewJob/Invoice/InvoiceBuyer";
// import InvoiceOtherDetails from "@/Config/Export/CreateNewJob/Invoice/InvoiceOtherInfo";
import Udf from "@/Config/ImportJob/CreateNewJob/Udf/Udf";

// import ProductJobWork from "./ProductJsons/ProductJobWork";
// import ProductReExportSchema from "@/Config/Export/CreateNewJob/ProductJsons/ProductReExport";
// import ProductQuota from "@/Config/Export/CreateNewJob/ProductJsons/ProductQuota";
// import ProductARE from "./ProductJsons/ProductARE";
// import ShipingBillPrinting from "./Shipment/ShipingBillPrinting";
// import Control from "@/Config/Export/CreateNewJob/ProductJsons/ProductControlpop";
// import productiondetails from "@/Config/Export/CreateNewJob/ProductJsons/ProductProductionpop";
// import ProductDUCInfo from "./ProductJsons/ProductDUCInfo";

// import ProductDOCInfo from "./ProductJsons/ProductDOCInfo";
import Note from "@/Config/ImportJob/CreateNewJob/Notes/Note";
// import ProductSinglewindowpop from "./ProductJsons/ProductSinglewindowpop";
// import ProductConsititpop from "./ProductJsons/ProductConsititpop";
// import ProductDEPBjson from "./ProductJsons/ProductDEPBjson";
// import ProductDEPBpopjson from "./ProductJsons/ProductDEPBpopjson";
// import ProductSanchit from "./eSanchit/ProductSanchit";
import Requirement from "@/Config/ImportJob/CreateNewJob/Requiremwnt/Requirement";
// import { LuSearch } from "@/Components/Icons/Icons";
// import ProductDRFC from "./ProductJsons/ProductDRFC";
// import ProductDRFCjson from "./ProductJsons/ProductDRFCjson";
// import Annexdetails from "./Shipment/Annexdetails";
// import AnnexPopupJson from "./Shipment/AnnexPopupJson";
// import { mapDEPBRequest } from "@/redux/mappers/Export/CreateNewJob/DEPBMapper";
import ProductTabBox from "@/Views/ImportJob/CreateNewJob/Product/ProductTabBox";
import SezInfo from "@/Config/ImportJob/CreateNewJob/SEZInfo/SezInfo";
import { mapImporterRequest } from "@/redux/mappers/Import/CreateNewJob/GeneralPageMaper";
import InvoiceSupplierLeft1 from "./Invoice/InvoiceSupplierLeft1";
import InvoiceSummaryCard from "@/Views/ExportJob/CreateNewJob/InvoiceTab/InvoiceSummaryCard";
import ProductMain from "./Product/ProductMain";
import Scheme from "./Product/ProductGeneral/Scheme";
import ManufactureDetails from "./Product/ProductGeneral/ManufactureDetails";
import ProductSezInfo from "./Product/ProductGeneral/ProductSezInfo";
import ProductExBond from "./Product/ProductGeneral/ProductEx-bond";
import ProductExBondForm from "./Product/ProductGeneral/ProductEx-bondForm";
import ProductLoad from "./Product/ProductLoad";
import ProductSinglewindowpop from "@/Config/ImportJob/CreateNewJob/Product/ProductSinglewindowpop";
import ProductConsititpop from "@/Config/ImportJob/CreateNewJob/Product/ProductConsititpop";
import ProductProductionpop from "@/Config/ImportJob/CreateNewJob/Product/ProductProductionpop";
import ProductControlpop from "@/Config/ImportJob/CreateNewJob/Product/ProductControlpop";
import Relsvb from "./Invoice/Relsvb";
import InvoiceOtherDetails from "@/Config/ImportJob/CreateNewJob/Invoice/InvoiceOtherDetails";
import FTAinfo from "./Product/FTAinfo";
import Productlicschemejson from "./Product/ProductLic/Productlicschemejson";
import Productlicjson from "./Product/ProductLic/Productlicjson";
import Productlicaddjson from "./Product/ProductLic/Productlicaddjson";
// import InvoiceMain from "@/Config/Export/CreateNewJob/Invoice/invoiceBuyer";
import InvoiceMain from "@/Config/ImportJob/CreateNewJob/Invoice/InvoiceTable";
import EntityCustomizedList from "./Entity/EntityCustomizedList";
//import ProductSanchit from "src/Views/ImportJob/CreateNewJob/eSanchit/ProductE-Sanchit";
import ProductSanchit from "@/Config/ImportJob/CreateNewJob/Esanchit/ProductSanchit";
import { mapFormToInvoiceSupplierAPI } from "@/redux/mappers/Import/CreateNewJob/InvoiceSupplierMapper";
import Bondcert from "./Bond/Bondcert";
import ImportProductReimport from "./Product/ProductReImport/ImportProductReimport";
import InvoiceOtherCharge from "../../../Config/ImportJob/CreateNewJob/Invoice/InvoiceOtherCharge";
import ProductSanchitFilter from "./Esanchit/ProductSanchitFilter";
import TotalValue from "../../../Views/ImportJob/CreateNewJob/TotalValue";
import CustDuty from "../../../Config/ImportJob/CreateNewJob/Product/CustDuty"
import GST from "../../../Config/ImportJob/CreateNewJob/Product/GST";
import OthDuties from "../../../Config/ImportJob/CreateNewJob/Product/OtherDuties";
import CentralExcise from "../../../Config/ImportJob/CreateNewJob/Product/CentralExcise";

export const ImportCreateNewJobSidebarItems = (formData) => {
  const hasJobNumber = formData?.general?.importJobNumber ?? false;
  // console.log("isjobnumber available",hasJobNumber, formData)
  // const hasInvoice = formData?.general?.isInvoiceAvailable ?? false
  const hasInvoiceMain =
    (formData?.invoiceMain?.length ?? 0) > 0;
    const isInvoiceAvailable = formData?.general?.isInvoiceAvailable === true 
    const hasInvoice = hasInvoiceMain ? true : isInvoiceAvailable
  const hasProduct = formData?.productMain?.length != 0 ? true : false;
  const selectedInvoice =
    formData?.invoiceMain?.find((invoice) => invoice?.selected === true) ||
    null;

  // console.log("hasInvoice", hasInvoice, hasProduct)
  return [
    {
      id: "general",
      label: "General",
      disabled: false,
      schema: GeneralSchema,
      api: "importer",
      type: "form",
      mapper: mapImporterRequest,
    },
    {
      id: "entity",
      label: "Entity",
      disabled: !hasJobNumber,
      api: "importentity",
      type: "table",
      schema: EntityCustomizedList,
      buttons: [
        {
          label: "Add New Entity",
          icon: "LuPlus",
          action: "openForm",
        },
      ],
      visibleFields: [
        { key: "importEntityType", label: "Type", width: 100 },
        { key: "importEntityName", label: "Name", width: 150 },
        { key: "importEntityState", label: "State", width: 150 },
        { key: "importEntityMobile", label: "Mobile", width: 150 },
        { key: "importEntityAddress", label: "Address", width: 250 },
        { key: "importEntityCountry", label: "Country", width: 150 },
        { key: "importEntityCity", label: "City", width: 150 },
      ],
      expandedFields: [
        { key: "importEntityFax", label: "Fax", width: 100 },
        { key: "importEntityPostalCode", label: "Postal Code", width: 100 },
        {
          key: "importEntityContactPerson",
          label: "Contact Person",
          width: 100,
        },
        { key: "importEntityEmail", label: "Email", width: 100 },
        { key: "importEntityTelephone", label: "Telephone", width: 100 },
      ],
    },

    {
      id: "importSezInfo",
      label: "SEZ Info",
      schema: SezInfo,
      type: "form",
      api: "importSez",
      // disabled: true,
      disabled: !hasJobNumber,
    },
    {
      id: "shipment",
      label: "Shipment",
      disabled: !hasJobNumber,
      type: "table",
      schema: ShipmentMainJson,
      api: "importshipment",
      buttons: [
        {
          label: "Copy Row",
          icon: "LuCopy",
          action: "copyRow",   
          ownerConfig: "shipment", 
        },
        {
          label: "Add New Shipment",
          icon: "LuPlus",
          action: "openForm",
        },
      ],
      visibleFields: [
        { key: "importShipmentAirline", label: "AirLine", width: 250 },
        { key: "importShipmentFlightNo", label: "FlightNo", width: 150 },
        {
          key: "importShipmentFlightDate",
          label: "Flight/Inward Date",
          width: 150,
        },
        { key: "importShipmentIGMNo", label: "IGM No", width: 150 },
        { key: "importShipmentIGMDate", label: "IGM Date", width: 150 },
      ],
      expandedFields: [
        { key: "importShipmentMAWBNo", label: "Mawb No", width: 150 },
        { key: "importShipmentMAWBDate", label: "Mawb Date", width: 100 },
        { key: "importShipmentHAWBNo", label: "HAWB NO", width: 100 },
        { key: "importShipmentHAWBDate", label: "HAWB Date", width: 100 },
        { key: "importShipmentPackages", label: "Packages", width: 100 },
        { key: "importShipmentGrossWeight", label: "GrossWeight", width: 100 },
        { key: "importShipmentNetWeight", label: "NetWeight", width: 100 },
        { key: "importShipmentVolume", label: "Volume", width: 100 },
        {
          key: "importShipmentChargeableWeight",
          label: "ChargeableWeight",
          width: 100,
        },
        { key: "importShipmentMarksandNos", label: "MarksandNos", width: 100 },
      ],
    },
    {
      label: "Invoice",
      disabled: !hasJobNumber,
      type: "tab",
      component: InvoiceSummaryCard,
      componentProps: {
        customMessage: "Welcome to Invoice Tab",
        totalInvoiceValue: selectedInvoice?.totalInvoiceValue ?? 0,
        totalProductValue: selectedInvoice?.totalProductValue ?? 0,
        invoiceNumber: selectedInvoice?.importInvoiceNumber ?? "-",
        toi: selectedInvoice?.importInvoiceTOI ?? "-",
        currentInvoiceValue: selectedInvoice?.importInvoiceValue ?? 0,
        currentProductValue: selectedInvoice?.importProductValue ?? 0,
        currency: formData?.invoiceMain?.[0]?.importCurrency?.name || "",
      },
      schema: InvoiceMain,
      buttons: [
        {
          label: "Copy Row",
          icon: "LuCopy",
          action: "copyRow",   
          ownerConfig: "invoiceMain", 
          disabled: !hasInvoice,

        },
         {
          label : "Declarations",
          subComponent : "InvoiceDeclaration",
          action: "openButtonSubDialog",
        },
        {
          label: "View Product",
          icon: "LuBox",
          action: "viewProduct",
        },
        {
          label: "Quick Entry",
          icon: "LuFileMinus",
          action: "quickEntry",
        },
        {
          label: "Add New Invoice",
          icon: "LuPlus",
          action: "openForm",
          ownerConfig: "invoiceMain",
        },

      ],
      subTabs: [
        {
          id: "invoiceMain",
          label: "Main",
          type: "table",
          schema: InvoiceMain,
          api: "invoiceMain",
          visibleFields: [
            { key: "importInvoiceNumber", label: "Invoice Number", width: 200 },
            { key: "importInvoiceDate", label: "Date", width: 180 },
            { key: "importInvoiceTOI", label: "TOI", width: 200 },
            { key: "importInvoiceTOIPlace", label: "TOI & Place", width: 200 },
            { key: "importCurrency", label: "Currency", width: 120 },
          ],
          expandedFields: [

            {
              key: "importProductValue",
              label: "Product Value",
              width: 150,
            },
            {
              key: "importInvoiceValue",
              label: "Invoice Value",
              width: 150,
            },
            {
              key: "otherCharges",
              label: "Other Charges",
              width: 150,
            },
          ],
        },
        {
          id: "InvoiceOtherCharges",
          label: "Other Charges",
          type: "form",
          api: "InvoiceOtherCharges",
          attachData: "invoiceMain",
          schema: InvoiceOtherCharge,
          disabled: !hasInvoice,

        },
        {
          id: "invoiceSupplierAndSellerDetails",
          label: "Supplier & Seller Details",
          type: "form",
          schema: InvoiceSupplierLeft1,
          api: "invoiceSupplier",
          disabled: !hasInvoice,
          attachData: "invoiceMain",
          mapper: mapFormToInvoiceSupplierAPI,
        },
        {
          id: "invoiceRel&SVBDetails",
          label: "Rel & SVB Details",
          type: "form",
          disabled: !hasInvoice,
          schema: Relsvb,
          attachData: "invoiceMain",
          api: "importinvoiceSvb",
        },
        {
          id: "invoiceOtherDetails",
          label: "Other Details",
          type: "form",
          disabled: !hasInvoice,
          schema: InvoiceOtherDetails,
          attachData: "invoiceMain",
          api: "invoiceOtherDetails",
        },
        {
          id: "InvoiceCharges",
          label: "Value Total(Calculated)",
          component: TotalValue,
          disabled: !hasInvoice,

        }
      ],
    },
    {
      label: "Product",
      disabled: !hasInvoice,
      type: "tab",
      component: ProductTabBox,
      schema: ProductMain,
      titleButtons: [
        {
          label: "Summary Of this Product",
          action: "openDialog",
          component: "SummaryPopover",
          onClick: "handleOpen",
        },
      ],
      buttons: [
        {
          label: "Copy Row",
          icon: "LuCopy",
          action: "copyRow",   
          ownerConfig: "productMain", 
          disabled: !hasProduct,
        },
        {
          label: "Update Master",
          action: "updateMaster",
        },
        {
          label: "Add New Product",
          icon: "LuPlus",
          action: "openForm",
          ownerConfig: "productMain",
        },
      ],
      subTabs: [
        {
          id: "productMain",
          label: "Main",
          type: "table",
          schema: ProductMain,
          api: "importproductMain",
          replaceMasterId: "invoiceMain",
          visibleFields: [
            {
              key: "importProductMainDescriptionId",
              label: "Description",
              editable: false,
              height: "44px",
              width: "100px",
            },
            {
              key: "importProductMainCTHorHSNCode",
              label: "RITC",
              editable: true,
              width: "145px",
              height: "30px",
              disabled: true,
            },
            {
              key: "importProductMainQuantity",
              label: "Quantity",
              editable: true,
              //disabled: true,
              width: "145px",
              height: "30px",
            },

            {
              key: "importProductMainUnitPrice",
              label: "Unit Price",
              editable: false,
              width: "130px",
            },
          ],
          expandedFields: [
            //  { key: "importProductMainAmount", label: "", width: 100 },
            { key: "importProductMainAmount", label: "Amount", width: 100 },
          ],
        },
        {
          id: "productGeneral",
          label: "General",
          type: "tab",
          disabled: !hasProduct,
          // api: "productGeneral",
          replaceMasterId: "productMain",
          subTabs: [
            {
              id: "SchemeAndGenericDescription",
              label: "Scheme And Generic Description",
              api: "importSchemeGeneric",
              type: "form",
              schema: Scheme,
              replaceMasterId: "productMain",
            },
            {
              id: "ProductManufacturerDetails",
              label: "Manufacturer Details",
              type: "form",
              api: "importManufacturer",
              replaceMasterId: "productMain",
              schema: ManufactureDetails,
            },
            {
              id: "productExBondInfo",
              label: "Ex-Bond Info",
              type: "formWithTable",
              // disabled: true,
              replaceMasterId: "productMain",
              data: [
                {
                  type: "form",
                  schema: ProductExBondForm,
                },
                {
                  type: "table",
                  schema: ProductExBond,
                  subButtons: [
                    {
                      label: "Add",
                      icon: "LuPlus",
                      onClick: "openForm",
                    },
                  ],
                  visibleFields: [
                    { key: "exportControlType", label: "Type", width: 150 },
                    {
                      key: "exportControllocation",
                      label: "Location",
                      width: 150,
                    },
                    {
                      key: "exportControlStartDate",
                      label: "Start Date",
                      width: 150,
                    },
                    {
                      key: "exportControlEndDate",
                      label: "End Date",
                      width: 150,
                    },
                    { key: "exportControlResult", label: "Result", width: 150 },
                  ],
                },
              ],
            },
            {
              id: "ProductSezInfo",
              label: "SezInfo",
              type: "table",
              api: "importProductSezinfo",
              disabled: !hasProduct,
              replaceMasterId: "productMain",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              schema: ProductSezInfo,
              visibleFields: [
                { key: "sezzInvSrNo", label: "Sez Inv SrNo", width: 150 },

                {
                  key: "sezzItemSrNo",
                  label: "SEZ-Z Item Sr",
                  width: 150,
                },
                {
                  key: "sezBENo",
                  label: "BE No ",
                  width: 170,
                },
                {
                  key: "sezBEDate",
                  label: "BE Date",
                  width: 150,
                },
                {
                  key: "sezBELocation",
                  label: "BE Location",
                  width: 150,
                },
                {
                  key: "sezCode",
                  label: "Code",
                  width: 150,
                },
                {
                  key: "sezQuantity",
                  label: "Quantity",
                  width: 150,
                },
              ],
            },
          ],
        },

        {
          id: "productLoading",
          label: "Loading",
          type: "form",
          schema: ProductLoad,
          api: "importProductLoading",
          replaceMasterId: "productMain",
          disabled: !hasProduct,
        },
        {
          id: "productCustDuty",
          label: "Cust.Duty",
          type:"form",
          schema: CustDuty,
          api: "ProductCustDuty",
          replaceMasterId: "productMain",
          disabled: !hasProduct,
        },
        {
          id: "productGST",
          label: "GST",
          type:"form",
          schema: GST,
          api:"ProductGST",
          replaceMasterId: "productMain",
          disabled: !hasProduct,

        },
        {
          id: "productOtherDuty",
          label: "Oth.Duties",
          type:"form",
          schema: OthDuties,
          api:"ProductOtherDuties",
          replaceMasterId: "productMain",
          disabled: !hasProduct,
        },
        {
          id: "productCentralExcise",
          label: "Central Excise",
          type:"form",
          schema: CentralExcise,
          disabled: !hasProduct,

        },
        {
          id: "productSingleWindow",
          label: "Single Window",
          disabled: !hasProduct,
          type: "tab",
          checkBox: [
            {
              label: "Single Window",
            },
          ],
          subTabs: [
            {
              id: "additionalInfo",
              label: "Additional Info",
              api: "importAdditionalInfo",
              type: "table",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              schema: ProductSinglewindowpop,
              replaceMasterId: "productMain",
              visibleFields: [
                {
                  key: "importAdditionalinfoType",
                  label: "Type",
                  editable: false,
                  height: "44px",
                  width: "100px",
                },
                {
                  key: "importAdditionalinfoQualifier",
                  label: "Qualifier",
                  editable: true,
                  width: "145px",
                  height: "30px",
                  disabled: true,
                },
                {
                  key: "importAdditionalinfoCode",
                  label: "Code",
                  editable: true,
                  disabled: true,
                  width: "145px",
                  height: "30px",
                },
                {
                  key: "importAdditionalinfoInformation",
                  label: "Information",
                  editable: true,
                  width: "140px",
                  height: "30px",
                },
                {
                  key: "importAdditionalinfoMeasure",
                  label: "Measure",
                  editable: false,
                  width: "130px",
                },
                {
                  key: "importAdditionalinfoMeasureUnit",
                  label: "Measure Unit",
                  editable: false,
                  width: "130px",
                },
              ],
            },
            {
              id: "consitituents",
              label: "Consitituents",
              type: "table",
              api: "importConstituents",
              replaceMasterId: "productMain",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              schema: ProductConsititpop,
              visibleFields: [
                { key: "importConstituentName", label: "Name", width: 150 },
                { key: "importConstituentCode", label: "Code", width: 150 },
                {
                  key: "importConstituentPercentage",
                  label: "Percentage",
                  width: 150,
                },
                { key: "importConstituentYield", label: "Yield %", width: 150 },
                { key: "importConstituentActive", label: "Active", width: 150 },
              ],
            },
            {
              id: "controldetails",
              label: "Control Details",
              type: "table",
              api: "importControlDetail",
              replaceMasterId: "productMain",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                { key: "importControlType", label: "Type", width: 150 },
                { key: "importControllocation", label: "Location", width: 150 },
                {
                  key: "importControlStartDate",
                  label: "Start Date",
                  width: 150,
                },
                { key: "importControlEndDate", label: "End Date", width: 150 },
                { key: "importControlResult", label: "Result", width: 150 },
              ],
              schema: ProductControlpop,
            },
            {
              id: "productiondetails",
              label: "Production Details",
              type: "table",
              api: "importProductionDetail",
              replaceMasterId: "productMain",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              schema: ProductProductionpop,
              visibleFields: [
                { key: "importProductBatchId", label: "Batch ID", width: 150 },
                {
                  key: "importProductBatchQuantity",
                  label: "Batch Quantity",
                  width: 150,
                },
                {
                  key: "importProductBatchunit",
                  label: "Batch Unit",
                  width: 150,
                },
                {
                  key: "importProductManufacuturerDate",
                  label: "Manufacture Date",
                  width: 170,
                },
                {
                  key: "importProductExpiryDate",
                  label: "Expiry Date",
                  width: 150,
                },
                {
                  key: "importProductBestBeforeDate",
                  label: "Best Before Date",
                  width: 150,
                },
              ],
            },
          ],
        },
        {
          id: "productFTA",
          label: "FTA",
          disabled: !hasProduct,
          type: "form",
          schema: FTAinfo,
          api: "importProductFTA",
          replaceMasterId: "productMain",
        },
        {
          id: "LIC",
          label: "LIC",
          type: "tab",
          disabled: !hasProduct,
          subTabs: [
            {
              id: "EOUDetails",
              label: "EOU Details",
              type: "formWithTable",
              api: "importEOUDetails",
              tableReplaceMasterId: "productMain",
              replaceMasterId: "productMain",
              tableApi: "importEOUDetailsItem",
              data: [
                {
                  type: "form",
                  schema: Productlicjson,
                },
                {
                  type: "table",
                  schema: Productlicaddjson,
                  subButtons: [
                    {
                      label: "Add",
                      icon: "LuPlus",
                      onClick: "openForm",
                    },
                  ],

                  visibleFields: [
                    {
                      key: "licRefNo",
                      label: "lic Re fNo",
                      width: 150,
                    },
                    {
                      key: "licNo",
                      label: "Document Name",
                      width: 120,
                    },
                    {
                      key: "licDate",
                      label: "Document Name",
                      width: 120,
                    },
                  ],
                  expandedFields: [
                    {
                      key: "licRegnNo",
                      label: "Lic RegnNo",
                      width: 120,
                    },
                    {
                      key: "licRegnDate",
                      label: "Lic RegnDate",
                      width: 120,
                    },
                    {
                      key: "licItemsSno",
                      label: "Lic ItemsSno",
                      width: 120,
                    },
                    {
                      key: "licValueDebited",
                      label: "Lic Value Debited",
                      width: 120,
                    },
                    {
                      key: "liccifValue",
                      label: "Lic CIF Value",
                      width: 120,
                    },
                    {
                      key: "licQuantity",
                      label: "Lic Quantity",
                      width: 120,
                    },
                    {
                      key: "licUnit",
                      label: "Lic Unit",
                      width: 120,
                    },
                    {
                      key: "licRegPort",
                      label: "Lic RegPort",
                      width: 120,
                    },
                  ],
                },
              ],
            },

            {
              id: "SchemeDetails",
              label: "Scheme Details",
              type: "form",
              schema: Productlicschemejson,
              api: "importLICScheme",
              replaceMasterId: "productMain",
              disabled: !hasProduct,
            },
          ],
        },
        {
          id: "reimport",
          label: "Re-Import",
          schema: ImportProductReimport,
          api: "reimport",
          type: "table",
          disabled: !hasProduct,
          replaceMasterId: "productMain",
          subButtons: [
            {
              label: "Add",
              icon: "LuPlus",
              action: "openForm",
              schema: ImportProductReimport,
            },
          ],
          visibleFields: [
            {
              key: "SrNo",
              label: "SrNo",
              width: 180,
            },
            {
              key: "importProductReImportSBNO",
              label: "S/B Number",
              width: 180,
            },
            {
              key: "importProductReImportPortofexport",
              label: "Port of Export",
              width: 200,
            },
            {
              key: "importProductReImportSBInvsno",
              label: "SBInvSrNo",
              width: 200,
            },
            {
              key: "importProductReImportSBitemsno",
              label: "SBItemSrNo",
              width: 200,
            },
          ],
          expandedFields: [
            {
              key: "importProductReImportNotnno",
              label: "Notn No",
              width: 200,
            },
            {
              key: "importProductReImportNotnsno",
              label: "Notn SrNo",
              width: 200,
            },
            {
              key: "importProductReImportFreight",
              label: "Freight",
              width: 200,
            },
            {
              key: "importProductReImportInsurance",
              label: "Insurance",
              width: 200,
            },
            {
              key: "importProductReImportCustomDuty",
              label: "Custom Duty",
              width: 200,
            },
            {
              key: "importProductReImportExciseDuty",
              label: "ExciseDuty",
              width: 200,
            },
            {
              key: "importProductReImportIGSTPaid",
              label: "IGST Paid",
              width: 200,
            },
            {
              key: "importProductReImportFileRefno",
              label: "File No/Ref No",
              width: 200,
            },
          ],
        },
        {
          id: "productOtherdetails",
          label: "Other Details",
          type: "form",
          disabled: !hasProduct,
          api: "productOtherInfo",
          schema: ProductOther,
          replaceMasterId: "productMain",
        },
        
      ],
    },
    {
      id: "bondcert",
      label: "Bond/Cert",
      schema: Bondcert,
      api: "bondcert",
      type: "table",
      disabled: !hasJobNumber,
      buttons: [
        {
          label: "Add",
          icon: "LuPlus",
          action: "openForm",
        },
      ],

      visibleFields: [
        {
          key: "SrNo",
          label: "SrNo",
          width: 180,
        },
        {
          key: "importBondCertType",
          label: "Bond/Cert",
          width: 180,
        },
        { key: "importBondCertNumber", label: "Number", width: 200 },
        { key: "importBondCertDateTime", label: "Date", width: 200 },
        { key: "importBondCertCommissionerate", label: "Rate", width: 200 },
        { key: "importBondCertDivision", label: "Division", width: 200 },
        { key: "importBondCertRange", label: "Range", width: 200 },
      ],
      expandedFields: [
        {
          key: "importBondCertRegisteredPort",
          label: "Registered Port",
          width: 200,
        },
      ],
    },
    {
      id: "esanchit",
      label: "eSanchit",
      type: "table",
      api: "esanchit",
      schema: ProductSanchit,
      extraApi: "eSanchitFilterImport",
      visibleFields: [
        { key: "SrNo", label: "SrNo", width: "20" },
        { key: "eSanchitDocumentLevel", label: "Doc.Level", width: 100 },
        { key: "eSanchitInvsrNo", label: "Inv.Sr.No", width: 150 },
        { key: "eSanchitItemSrNo", label: "Item Sr.No", width: 150 },
        { key: "eSanchitIRN", label: "Doc.IRN", width: 150 },
        { key: "eSanchitDocumentType", label: "Doc.Type", width: 200 },
      ],
      expandedFields: [
        { key: "eSanchitDocumentRefNo", label: "Doc.Ref.No", width: 150 },
        { key: "eSanchitIcegateId", label: "ICEGATE ID", width: 200 },
        { key: "eSanchitDateofIssue", label: "Doc.Issue date", width: 200 },
        { key: "eSanchitExpiryDate", label: "Doc.Expiry date", width: 200 },
        { key: "eSanchitPlaceofIssue", label: "Doc.Issued at", width: 200 },
        {
          key: "eSanchitDatetimeupload",
          label: "Doc.Upload date-time",
          width: 200,
        },
        {
          key: "eSanchitICegateFileName",
          label: "ICEGATE File name",
          width: 200,
        },
        { key: "eSanchitFileType", label: "File Type", width: 200 },
      ],
      buttons: [
        {
          label: "Filter",
          icon: "LuFilter",
          action: "openForm",
          schema: ProductSanchitFilter,
          extraApi: "eSanchitFilterImport",
        },
        {
          label: "Add",
          icon: "LuPlus",
          action: "openForm",
        },
      ],
      actions: [
        {
          icon: "FiEdit2",
          title: "Edit",
          handler: "handleEdit", 
        },
        {
          icon: "LuTrash2",
          title: "Delete",
          handler: "handleRemove",
        },
        {
          icon: "HiOutlineEye",
          title: "View",
          handler: "handleView",
          show: (row) =>
            row?.eSanchitAttachmentId || row?.eSanchitAttachment?.filePath,
        },
      ],
      disabled: !hasJobNumber,
    },

    {
      id: "exchRate",
      label: "Exch. Rate",
      disabled: !hasJobNumber,
      api: "exchangeRate",
      type: "tableWithFields",
      visibleFields: [
        { key: "code", editable: false, height: "44px", width: "100px" },
        {
          key: "custExchRate",
          label: "Cust Exch Rate",
          editable: true,
          width: "145px",
          height: "30px",
          parentKey: "custom", 
          type: "number",
        },
        {
          key: "nonStdCurr",
          label: "Non Std.Curr",
          editable: true,
          disabled: true,
          width: "145px",
          height: "30px",
          type: "number", 
        },
        {
          key: "exRate",
          label: "Ex. Rate",
          editable: true,
          width: "140px",
          height: "30px",
          parentKey: "revenue",
          type: "number", // important!
        },
        { key: "cfx", label: "CFX", editable: false, width: "130px" },
        {
          key: "exRateCfx",
          label: "Ex. Rate",
          editable: false,
          width: "130px",
          height: "30px",
        },
        {
          key: "agentExRate",
          label: "Agent Ex.Rate",
          editable: true,
          width: "130px",
          height: "30px",
          parentKey: "revenue",
          type: "number", // important!
        },
        {
          key: "cfxAgent",
          label: "CFX",
          editable: false,
          width: "130px",
          height: "30px",
          parentKey: "revenue",
        },
        {
          key: "exRateCost",
          label: "Ex. Rate",
          editable: false,
          width: "130px",
          height: "30px",
          parentKey: "cost",
        },
        {
          key: "cost",
          label: "Cost",
          editable: true,
          width: "130px",
          height: "30px",
          parentKey: "cost",
          type: "number", // important!
        },
      ],
      groupedHeaders: [
        { label: "Code", colSpan: 1, height: "44px" },
        { label: "Custom", colSpan: 2, height: "44px" },
        { label: "Revenue", colSpan: 6, height: "44px" },
        { label: "Cost", colSpan: 2, height: "44px" },
      ],
      actions: [],
    },

    // { label: "ICEGATE", disabled: true },
    // { label: "E-Doc", disabled: true },
    {
      id: "requirement",
      label: "Requirements",
      schema: Requirement,
      api: "requirement",
      type: "table",
      disabled: !hasJobNumber,

      buttons: [
        {
          label: "Add",
          icon: "LuPlus",
          action: "openForm",
        },
      ],

      visibleFields: [
        {
          key: "importRequirementDocumentName",
          label: "Document Name",
          width: 180,
          editable: true,
        },
        { key: "importRequirementDate", label: "Date", width: 200 },
      ],
      // disabled: !hasJobNumber,
    },
    {
      id: "udf",
      label: "UDF",
      disabled: !hasJobNumber,
      schema: Udf,
      api: "udf",
      type: "form",
    },
    // // { label: "Tracking" },
    {
      id: "importNotes",
      label: "Notes",
      type: "table",
      api: "exportNotes",

      schema: Note,
      visibleFields: [
        { key: "importNoteDate", label: "Date", width: 200 },
        { key: "importNotes", label: "Notes", width: 200 },
      ],

      buttons: [
        {
          label: "Add Notes",
          icon: "LuPlus",
          action: "openForm",
        },
      ],

      actions: [
        {
          icon: "FiEdit2",
          title: "Edit",
          handler: "handleEdit", // string reference to function
        },
        {
          icon: "LuTrash2",
          title: "Delete",
          handler: "handleRemove",
        },
        {
          icon: "HiOutlineEye",
          title: "View",
          handler: "handleView",
          // show: (row) => row?.exportNoteAttachmentId || row?.exportNoteAttachment?.filePath
        },
      ],
      disabled: !hasJobNumber,
    },

    {
      id: "importhistory",
      label: "History",
      api: "importhistoryApi",
      type: "table",
      disabled: !hasJobNumber,
      actions: [],
      buttons: [
        {
          label: "Refresh",
          action: "Refresh",
        },
      ],
      visibleFields: [
        { key: "importHistoryDateTime", label: "Date & Time", width: 150 },
        { key: "userName", label: "User ID", width: 150 },
        { key: "importHistoryLocation", label: "Location", width: 130 },
        { key: "importHistoryAction", label: "Action", width: 130 },
        { key: "importHistoryRemarks", label: "Remarks", width: 190 },
      ],
    },
  ];
};

export default ImportCreateNewJobSidebarItems;
